<template>
  <div class="non-service">
    <div class="non-service-title">
      <span>{{ $t("GPT.HISTORY.NON_SERVICE") }}</span>
      <i
        class="bx bx-chevron-down"
        v-if="showNonService"
        @click="showNonService = false"
      ></i>
      <i class="bx bx-chevron-up" v-else @click="showNonService = true"></i>
    </div>
    <div v-if="showNonService" class="non-service-content">
      {{ setting.ChatGPT_NonService }}
    </div>
  </div>
</template>

<script>
export default {
  name: "non-service-hours",
  data() {
    return {
      showNonService: true,
    };
  },
  computed: {
    setting() {
      return this.$store.state.gpt.setting;
    },
  },
};
</script>

<style lang="scss" scoped>
.non-service {
  font-size: 14px;
  color: #333;
  user-select: none;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1;
  .non-service-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 8px;
    box-shadow: 0px 2px 6px 0px #5252521a;
    i {
      cursor: pointer;
      font-size: 20px;
    }
  }
  .non-service-content {
    padding: 8px 16px;
    box-shadow: 0px 4px 6px 0px #a8a8a81a;
  }
}
</style>
